module.exports = __webpack_public_path__ + "img/delay-down.cfe6929.svg";